import { Channel, UserResponse } from "stream-chat";
import { BOOKS_CHANNEL_CUSTOM_TYPE, TASK_CHANNEL } from "constants/channelType";
import {
  ACCOUNT_MANAGER,
  BOOKKEEPER,
  HEAD_OF_SUPPORT,
  INKLE_CEO,
  INKLE_CTO,
  PREPARER,
  REVIEWER,
} from "constants/chatMemberType";

export const TAIL_ROLES = [HEAD_OF_SUPPORT, INKLE_CEO, INKLE_CTO];

const getStringField = (value: unknown): string | undefined =>
  typeof value === "string" ? value : undefined;

/** Roles shown as tags next to a user in the mention picker, most relevant first */
export const getMentionUserRoles = (
  channel: Channel,
  user: UserResponse
): string[] => {
  const customType = getStringField(channel.data?.custom_type);
  const isBookChannel = customType === BOOKS_CHANNEL_CUSTOM_TYPE;
  const isFilingChannel = customType === TASK_CHANNEL;

  const assignedRoles = [
    {
      memberId: channel.data?.assigned_agent_member_id,
      role: ACCOUNT_MANAGER,
    },
    {
      memberId: channel.data?.assigned_preparer_member_id,
      role: isBookChannel ? BOOKKEEPER : PREPARER,
    },
    {
      memberId: isFilingChannel
        ? channel.data?.assigned_reviewer_member_id
        : undefined,
      role: REVIEWER,
    },
  ]
    .filter(({ memberId }) => getStringField(memberId) === user.id)
    .map(({ role }) => role);

  if (assignedRoles.length > 0) return assignedRoles;

  const roleName = getStringField(user.role_name);
  if (roleName && TAIL_ROLES.includes(roleName)) return [roleName];

  return [];
};
